import React, { Component, PropTypes, PureComponent } from 'react';
import $ from "jQuery";
// import contacta from "../../../views/index.ejs"

export default class Contact extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      send: false,
      email: '',
      content: '',
      subject: 'Mail Form From Website'
    };

    this.validateEmail = this.validateEmail.bind(this)
  }
  validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return true;
  }
  updateEmail(evt) {

    this.setState({
      email: evt.target.value
    });
  }
  updateContent(evt) {
    this.setState({
      content: evt.target.value
    });
  }

  _handleSubmit(event) {
    // var mailData = this.state;
    // var email = $("#email").val();
    // if (this.validateEmail(email)) {
    //   $('#emailId').addClass('has-success');
    //   $('#emailContent').addClass('has-success');
    //   $('#success').removeClass('hiddenSuccess');
    //   $('#success').addClass('form-control-feedback');
    //   event.preventDefault();
    //   // this.props.callbackParent(mailData);
    // } else {
    //   $('#emailId').addClass('has-danger');
    //   event.preventDefault();
    // }



  }


  render() {

  }
  render() {


    // const sendmail = require('sendmail')();

    // sendmail({
    //     from: 'no-reply@yourdomain.com',
    //     to: 'test@qq.com, test@sohu.com, test@163.com ',
    //     subject: 'test sendmail',
    //     html: 'Mail of test sendmail ',
    //   }, function(err, reply) {
    //     console.log(err && err.stack);
    //     console.dir(reply);
    // });

    let mailAddress = "send@email.com"
    return (
      <div className="col-sm-12">
        <h3>Contact</h3>

        <section className="category cc-articles">

          <div className="col-sm-12">
            <span>Asociaţia  Umanitară  “Dreptul la viaţă” Huedin</span><br />
            <span>CUI  24817304</span><br />
            <span>Adresa: Piaţa Republicii nr.8, loc. Huedin, jud. Cluj</span><br />
            <span>E-mail: contact@dreptullaviata.ro</span><br />
            <span>Facebook: https://www.facebook.com/asociatiadreptullaviatahuedin/</span><br />

          </div>
          {/* <div className="col-sm-6">
          
            <form action="/send-email" method="post">
              <div id="emailId" className="form-group ">
                <small className="form-text text-muted">Email</small>
                <input type="text" value={this.state.email} onChange={this.updateEmail.bind(this)}
                  className="form-control form-control-success" id="inputSuccess1" />
              </div>
              <div id="emailContent" className="input-field">
                <small className="form-text text-muted">Mesaj</small>
                <textarea className="form-control" value={this.state.content}
                  onChange={this.updateContent.bind(this)}
                  name="emailcontent" id="emailcontent" />
                <div id="success" className="hiddenSuccess">Mesaj trimis</div>
              </div>
              <button type="button" className="btn btn-primary"
                onClick={this._handleSubmit.bind(this)}>Trimite</button>
            </form>
          </div> */}
        </section>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/screens/Contact/contact.js